export default function ecUtilService() {
  const isIE = /Trident/.test(navigator.userAgent),
    isIE11 = !!window.MSInputMethodContext && !!document.documentMode,
    isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1,
    isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
  return { isIE, isIE11, isFirefox, isChrome, download };

  function download(content, filename = '', mime = 'text/plain') {
    const blob = new Blob([content], { type: mime });
    // if (isIE()) { return window.navigator.msSaveBlob(blob, filename); }

    const size = blob.size,
      url = window.URL.createObjectURL(blob),
      a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    a.href = url;
    a.download = filename;
    a.click();
    document.body.removeChild(a);
  }
}
